<div
  class="ctn-image-disney"
  [ngClass]="{ almundo: brand === 'almundo', avantrip: brand === 'avantrip' }"
></div>
<div class="ctn-description">
  <div class="title">
    <h4>Beneficios por alojarte en Hoteles Resort <i>Disney</i></h4>
  </div>
  <ul>
    @for (benefit of benefitsDisney; track benefit) {
      <li>
        <mb-icon icon="check-simple"></mb-icon>
        <p>{{ benefit }}</p>
      </li>
    }
  </ul>
</div>
